import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BcService } from 'src/app/shared/services/bc/bc.service';
import { BpService } from 'src/app/shared/services/bp/bp.service';
import { NTHFlag } from 'src/app/shared/constants/flag';
import { GlobalSettingsService } from 'src/app/core/gobal-settings.service';
import { environment } from 'src/environments/environment';
import { UserModelDTO } from 'src/app/shared/dtos/userModelDTO';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { ModalAnnulationConfirmationComponent } from '../modal-annulation-confirmation/modal-annulation-confirmation.component';
import { DefinitionTypeBC } from 'src/app/shared/typeBCDefinitions';

export interface DialogData {
  icone: string;
  title: string;
  message: string;
  color: string;
  icon_color: string;
  dialogWidth: string;
  dialogHeight: string;
  type: string;
  statut: string;
  result: boolean;
  codeCa1: string;
  idSociete: number;
  nivStatus: number;
  fAnnule: NTHFlag;
  fDeprovis: NTHFlag;
  fLivre: NTHFlag;
  fHasBp: NTHFlag;
  listBp: boolean;
  bBloquer: boolean;
  fValide: NTHFlag;
  user: UtilisateurModel;
  bcSocieteId: number;
  bcCreateurId: number;
  bcCode: string;
  bcLibelle: string;
  bcStatus: string;
  bcType: string;
}
@Component({
  selector: 'app-modal-update-cancel',
  templateUrl: './modal-update-cancel.component.html',
  styleUrls: ['./modal-update-cancel.component.scss']
})

export class ModalUpdateCancelComponent implements OnInit {
  icone: string;
  title: string;
  message: string;
  color: string;
  iconColor: string;
  dialogWidth: string;
  dialogHeight: string;
  canValidate = false;
  canEditOrCreate = false;
  canCreate = false;
  canFacturate = false;
  canDeliver = false;
  canCancel = false;
  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3' , 'Validation 4'];
  user: UtilisateurModel;
  bcSocieteId: number;
  bcCreateurId: number;
  bcCode: string;
  bcLibelle: string;
  bcStatus: string;

  ifBpListMode: boolean;
  currentRoute: any;
  bpDisplayState: any;
  environment: boolean = environment.BP_ACTIF;

  definitionTypeBC = DefinitionTypeBC;

  constructor(public dialog: MatDialog,
              private toastr: ToastrService,
              public router: Router,
              private bcService: BcService,
              private bpService: BpService,
              public dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData,
              private globalSettingsService: GlobalSettingsService) {
    this.bpDisplayState = this.globalSettingsService.bpDisplayState;
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.verifyCurrentRoute();
    this.icone = this.data.icone !== undefined ? this.data.icone : '';
    this.title = this.data.title !== undefined ? this.data.title : '';
    this.iconColor = this.data.icon_color !== undefined ? this.data.icon_color : '';
    this.dialogWidth = this.data.dialogWidth !== undefined ? this.data.dialogWidth : '';
    this.dialogHeight = this.data.dialogHeight !== undefined ? this.data.dialogHeight : '';
    this.message = this.data.message;
    this.color = this.data.color;
    this.user = this.data.user;
    this.bcSocieteId = this.data.bcSocieteId;
    this.bcCreateurId = this.data.bcCreateurId;
    this.bcCode = this.data.bcCode;
    this.bcLibelle = this.data.bcLibelle;
    this.bcStatus = this.data.bcStatus;
    if (this.data.type === 'BC') {
      this.bcService.getAuthorisation(this.data.codeCa1, this.data.idSociete).subscribe((res: number[]) => {
        if (res.find(d => (d === this.data.nivStatus + 1))) {
          this.canValidate = true;
        }
        if (res.find(d => d === 2 || d === 3)) {
          this.canEditOrCreate = true;
        }
        if(res.find(d=>d === 1)){
          this.canCreate = true;
        }
        if (res.find(d => d === 2)) {
          this.canDeliver = true;
        }
      });
      /*
      Plus utilisé, trop d'impact sur le process métier.
      const canDeliverModifCancelBlockBc = this.user.droits.filter(droit =>
        (droit.niveau === 1) &&
        (droit.type.toUpperCase() === 'ADMIN') &&
        (droit.idSociete === this.bcSocieteId)
      );
      if ((canDeliverModifCancelBlockBc && canDeliverModifCancelBlockBc.length > 0) || this.bcCreateurId === this.user.id){
        this.canDeliverModifCancelBlockBc = true;
      }
      */
    } else {
      this.bpService.getAuthorisation(this.data.codeCa1, this.data.idSociete).subscribe((res: number[]) => {
        if (res.find(d => (d === this.data.nivStatus + 1) && d !== 6)) {
          this.canValidate = true;
        }
        if (res.find(d => d === 2 || d === 3)) {
          this.canEditOrCreate = true;
        }
        if (res.find(d => d === 2)) {
          this.canCancel = true;
        }
        if (res.find(d => d === 6) && this.data.nivStatus >= 6 && this.data.nivStatus !== 11) {
          this.canFacturate = true;
        }
      });
    }
  }

  onOpenModalModifCancel() {
    const dialogConfirmation = this.dialog.open(ModalAnnulationConfirmationComponent, {
      data: {
        title: 'Confirmez-vous l’annulation de ce bon de commande ?',
        type: 'BC',
        statut: this.bcStatus,
        message: 'Attention ! L’annulation du bon de commande entraînera\nle non traitement et le non paiement des factures\nréceptionnées !',
        icone: 'warning',
        icon_color: 'warn',
        color: 'danger',
        idSociete: this.bcSocieteId,
      }
    });
    return dialogConfirmation.afterClosed().subscribe((resultat) => {
      if (resultat) {
        this.dialogRef.close("Annuler");
      }
    });
  }

  onModalCancel(): void {
    this.dialogRef.close(false);
  }

  onModalConfirm(action): void {
    this.data.result = true;
    this.dialogRef.close(action);
  }

  onModalConfirmAnnulation(): void {
    if (this.data.type === 'BC')
    {
      this.data.result = true;
      this.dialogRef.close('Annuler');
    } else {
      this.data.result = true;
      this.dialogRef.close(null);
    }
  }

  verifyCurrentRoute(): void {
    if (this.currentRoute === '/list-bp') {
      this.ifBpListMode = true;
    } else {
      this.ifBpListMode = false;
    }
  }

  debloquer() {
    if(this.data.bBloquer) {
      this.data.result = true;
      this.dialogRef.close('Débloquer');
    } else {
      this.data.result = true;
      this.dialogRef.close('Bloquer');
    }
  }
}
